import axios from "axios";
import { HOST_URL } from "../constants/Constants";

export const getAllChecklists = async () => {
  const data = await axios
    .get(HOST_URL + "/checklists/getAll", {
      withCredentials: true,
    })
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

export const updateChecklist = async (checklist) => {
  //axios post request to update checklist

  const data = await axios
    .post(
      HOST_URL + "/checklists/update",
      {
        data: checklist,
      },
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};

//add new checklist
export const addChecklist = async (checklist) => {
  //axios post request to add checklist
  const data = await axios
    .post(
      HOST_URL + "/checklists/add",
      {
        data: checklist,
      },
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      console.log("error = ", error);
    });
  return data.data;
};
